const request = async(path, method, body) => {
  const url = `${process.env.API_URL}${path}`;

  let res;
  try {
    res = await fetch(url, {
      method,
      headers: ['POST', 'PUT', 'PATCH', 'DELETE'].includes(method)
      ? { 'Content-Type': 'application/json' }
      : {},
      credentials: 'include',
      body: ['POST', 'PUT', 'PATCH', 'DELETE'].includes(method)
      ? JSON.stringify(body)
      : null
    });
  } catch {
    throw { status: 0, message: 'Unable to connect to server. Please try again later.' };
  }

  if (res.status === 429) {
    throw { status: 429, message: 'Too many requests. Please wait a few minutes and try again.' };
  }

  const json = await res.json();

  if(!res.ok) throw json;
  return json;
};

export const post = (path, body) => request(path, 'POST', body);
export const get = path => request(path, 'GET');
export const put = (path, body) => request(path, 'PUT', body);
export const del = (path, body) => request(path, 'DELETE', body);
